
import { handleActions } from 'redux-actions'
import { FEATURE_AUDIO_CHAT, FEATURE_DYNAMIC_TURN_AUTH } from '../api/env'
import { updateFeatures } from '../actions/app'
import { logger } from '../lib/utils/logger'

const initialState = {
  audioChat: false,
  FEATURE_DYNAMIC_TURN_AUTH,
}

export const featuresReducer = handleActions({
  [updateFeatures] (prevState, action) {
    if (action.payload.agentDetails) {
      // update audioChat feature for agent platform
      let audioChat = { ...prevState }
      if (FEATURE_AUDIO_CHAT && typeof FEATURE_AUDIO_CHAT === 'string' && FEATURE_AUDIO_CHAT.length > 0) {
        try {
          const platforms = FEATURE_AUDIO_CHAT.split(',').map((p) => p.toLowerCase().trim())
          const { agentDetails: { platformType } } = action.payload
          audioChat = platforms.includes(platformType.toLowerCase())
        } catch (error) {
          logger('audio chat feature error', error)
        }
      }
      return {
        ...prevState,
        audioChat,
      }
    }
    return prevState
  },
}, initialState)
